import * as React from 'react';
import classNames from 'classnames';
import {InboundState} from '../../InboundInterfaces';

interface StatusCellProps {
  status: InboundState;
}

// Helper function to convert a string to Title Case (e.g., "receiving" -> "Receiving")
const toTitleCase = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const StatusCell: React.FC<StatusCellProps> = ({status}) => {
  return (
    <div style={{display: 'flex', alignItems: 'center'}}>
      <span className={classNames('dot', status)} style={{marginRight: '8px'}}></span>
      <span>{toTitleCase(status)}</span>
    </div>
  );
};

export default StatusCell;
